<template>
    <div class="topbar-container">
        <div class="scrollbar-container">
            <validation-observer v-slot="{ invalid }">
                <div class="line"></div>
                <div class="input-wrap">
                    <div class="header c_999 fz_24">驾驶证基本信息</div>
                    <validation-provider name="车主姓名" rules="required" v-slot="{ errors }">
                        <van-field
                            v-model="formData.registeredName"
                            clearable
                            maxlength="10"
                            label="车主姓名"
                            placeholder="请输入车主姓名"
                        >
                            <zb-warning slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                    <validation-provider name="驾驶证号" rules="required|idCard" v-slot="{ errors }">
                        <van-field
                            v-model="formData.number"
                            clearable
                            type="tel"
                            maxlength="18"
                            placeholder="15位或18位数完整驾驶证号"
                        >
                            <div
                                slot="label"
                                class="bh bstart fz_30 c_333"
                                @click="onShowImg('./img/number.png')"
                            >
                                驾驶证号
                                <van-icon name="warning-o" class="c_red" />
                            </div>
                            <zb-warning slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                    <validation-provider name="档案编号" rules="required|digits:12" v-slot="{ errors }">
                        <van-field
                            v-model="formData.fileNo"
                            clearable
                            type="tel"
                            maxlength="12"
                            placeholder="12位数完整档案编号"
                        >
                            <div
                                slot="label"
                                class="bh bstart fz_30 c_333"
                                @click="onShowImg('./img/fileNo.png')"
                            >
                                档案编号
                                <van-icon name="warning-o" class="c_red" />
                            </div>
                            <zb-warning slot="right-icon" :message="errors[0]" />
                        </van-field>
                    </validation-provider>
                </div>
                <div class="bh bc">
                    <van-button :disabled="invalid" class="btn btn-goodbuy" @click="onSaveClick">
                        <span class="fz_30 btn-span">保存并查询</span>
                    </van-button>
                </div>
            </validation-observer>
        </div>
        <DialogImg ref="dialogImg" :data="imgList"></DialogImg>
    </div>
</template>
<script>
import { user } from "@/mixin/user";
import { mixinBreak } from "@/mixin/break";
import DialogImg from "@/components/dialog/Img";
import { addDriving } from "@/api/break";
export default {
    mixins: [user, mixinBreak],
    name: "BreakDrivingEdit",
    components: { DialogImg },
    data() {
        return {
            checked: false,
            imgList: [],
            maskFlag: false,
            formData: {
                registeredName: "",
                fileNo: "",
                number: ""
            }
        };
    },
    methods: {
        onShowImg(v) {
            this.imgList = [v];
            this.$refs.dialogImg.onShowImg(0);
        },
        userLoginend() {
            // 测试环境处理
            if (this.$store.state.isDev) {
                this.formData = {
                    registeredName: "赵修瞾",
                    fileNo: "510701283089",
                    number: "510725198604062416"
                };
                // this.formData = {
                //     registeredName: "郭豪",
                //     fileNo: "320103843151",
                //     number: "332624199608262117"
                // };
            }
        },
        onSaveClick() {
            const me = this;
            addDriving(me.formData).then(res => {
                // 刷新驾照列表，避免用户不支付时数据不更新
                // 取消支付或者从支付页面返回
                me.$store.dispatch("illegal/drivingList", true);
                me.getDriving(res.data, true);
            });
        }
    }
};
</script>
<style scoped lang="scss">
.scrollbar-container {
    background: #f1f2f3;

    .input-wrap {
        background-color: #fff;
        padding: 0 40px;
        .header {
            padding: 30px 0;
            line-height: 1;
        }
        /deep/ .van-cell {
            padding: 50px 0;
            border-top: 1px solid #dcdcdc;
        }
        /deep/ .van-field__label {
            width: 200px;
        }
    }
    .btn-goodbuy {
        margin-top: 60px;
        width: 510px;
        height: 76px;
    }
}
</style>
